import React from 'react';

export function Rituals() {
  return (
    <div className="space-y-4">
      <div className="bg-primary rounded-lg p-4 text-center h-[50px] flex items-center justify-center">
        <h1 className="text-xl text-white">RITUALES</h1>
      </div>
      
      <div className="grid grid-cols-1 gap-4">
        <div className="bg-white rounded-lg shadow-md">
          <div className="p-6 space-y-4">
            <p className="text-gray-600">
              Los rituales son tratamientos que he creado para combinar todos los beneficios de una higiene facial con los de distintas técnicas de masaje.
              <br /><br />
              Según el ritual que elijas y el objetivo que queramos conseguir, las técnicas de masaje utilizadas podrán ser: quiromasaje, Gua Sha, lifting facial japonés o drenaje linfático.
              <br /><br />
              Los beneficios del masaje facial son múltiples y se traducen en una piel saludable, luminosa, relajada y descongestionada.
              <br /><br />
              Todos incluyen extracción y depilación de cejas y/o labio, si es necesario.
            </p>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-md">
          <div className="p-6 space-y-4">
            <h2 className="text-lg font-semibold text-primary">Purificante</h2>
            <p className="text-gray-600">
              Este ritual está pensado especialmente para pieles grasas, con tendencia acnéica, congestionadas o sensibles.
              <br /><br />
              En este caso, la técnica de masaje más utilizada será el drenaje linfático, manual o con Gua Sha, que ayudará a eliminar toxinas y a purificar la piel desde dentro hacia afuera.
              <br /><br />
              Con este ritual conseguirás una piel limpia, equilibrada y revitalizada.
              <br /><br />
              <strong>Duración aproximada:</strong> 1h 30 min
              <br />
              <strong>Precio:</strong> 68€
            </p>
            <a 
              href="https://api.whatsapp.com/send?phone=+34654261502&text=Hola%20Sandra!" 
              className="block mt-4 bg-primary text-white text-center px-4 py-2 rounded-full hover:bg-primary/90 transition-colors font-medium"
            >
              CITA PREVIA
            </a>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-md">
          <div className="p-6 space-y-4">
            <h2 className="text-lg font-semibold text-primary">Hidratante y antiarrugas</h2>
            <p className="text-gray-600">
              Este ritual está dirigido a cualquier tipo de piel, sobre todo si notas tu piel seca, deshidratada, con arrugas o con falta de luminosidad. Está pensado especialmente para pieles a partir de los 25 años que quieran empezar a prevenir arrugas.
              <br /><br />
              La técnica de masaje más utilizada es el Gua Sha.
              <br /><br />
              Con este ritual conseguirás minimizar arrugas, además de una piel limpia, luminosa e hidratada.
              <br /><br />
              <strong>Duración aproximada:</strong> 1h 30 min
              <br />
              <strong>Precio:</strong> 68€
            </p>
            <a 
              href="https://api.whatsapp.com/send?phone=+34654261502&text=Hola%20Sandra!" 
              className="block mt-4 bg-primary text-white text-center px-4 py-2 rounded-full hover:bg-primary/90 transition-colors font-medium"
            >
              CITA PREVIA
            </a>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-md">
          <div className="p-6 space-y-4">
            <h2 className="text-lg font-semibold text-primary">Relajante</h2>
            <p className="text-gray-600">
              Este ritual es perfecto para cualquier tipo de piel, especialmente para pieles cansadas, estresadas, que necesiten unos mimos extra.
              <br /><br />
              Incluye un masaje cráneo-facial que abarca también la zona del cuello, los hombros y el escote.
              <br /><br />
              Con este ritual, además de recuperar tu piel, conseguirás desconectar del estrés y relajar cuerpo y mente.
              <br /><br />
              <strong>Duración aproximada:</strong> 1h 30 min
              <br />
              <strong>Precio:</strong> 68€
            </p>
            <a 
              href="https://api.whatsapp.com/send?phone=+34654261502&text=Hola%20Sandra!" 
              className="block mt-4 bg-primary text-white text-center px-4 py-2 rounded-full hover:bg-primary/90 transition-colors font-medium"
            >
              CITA PREVIA
            </a>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-md">
          <div className="p-6 space-y-4">
            <h2 className="text-lg font-semibold text-primary">Antiedad global</h2>
            <p className="text-gray-600">
              Este ritual está dirigido a las pieles que buscan tratar, de manera global, todos los signos del envejecimiento: arrugas, sequedad, deshidratación, flacidez o falta de luminosidad.
              <br /><br />
              Dependiendo de la necesidad se utilizarán distintas combinaciones de las técnicas de masaje mencionadas anteriormente.
              <br /><br />
              Con este ritual conseguirás devolverle a tu piel su firmeza, suavidad, brillo e hidratación.
              <br /><br />
              <strong>Duración aproximada:</strong> 2 horas
              <br />
              <strong>Precio:</strong> 80€
            </p>
            <a 
              href="https://api.whatsapp.com/send?phone=+34654261502&text=Hola%20Sandra!" 
              className="block mt-4 bg-primary text-white text-center px-4 py-2 rounded-full hover:bg-primary/90 transition-colors font-medium"
            >
              CITA PREVIA
            </a>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-md">
          <div className="p-6 space-y-4">
            <h2 className="text-lg font-semibold text-primary">Corporal</h2>
            <p className="text-gray-600">
              El ritual corporal es un masaje de espalda y cuello que incluye: Gua Sha corporal, puntos de acupresión en facial y estiramientos de cuello con toalla.
              <br /><br />
              Es un tratamiento que actúa de manera general sobre el organismo, produciendo múltiples beneficios.
              <br /><br />
              Este ritual te ayudará a liberar tensiones, a despejar tu mente y a conseguir un estado de equilibrio y relajación.
              <br /><br />
              <strong>Duración aproximada:</strong> 1h
              <br />
              <strong>Precio:</strong> 68€
            </p>
            <a 
              href="https://api.whatsapp.com/send?phone=+34654261502&text=Hola%20Sandra!" 
              className="block mt-4 bg-primary text-white text-center px-4 py-2 rounded-full hover:bg-primary/90 transition-colors font-medium"
            >
              CITA PREVIA
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}